module.exports = __webpack_public_path__ + "img/bu-wave.19569bb4.svg";